import React from 'react'
import { withIcon } from '../../withIcon'

function YandexEngIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M13.0843 17.9428V21H9.93743V15.8451L4 3H7.28329L11.9097 13.0489C12.8013 14.9689 13.0843 15.6366 13.0843 17.9428ZM19 3L15.1403 11.7032H11.9418L15.8015 3H19Z" stroke={color}/>
    </svg>
  )
}

export default withIcon(YandexEngIcon)
